import React from 'react'

interface NodeBaseActionsProps {
  onDelete?: () => void
  onDuplicate?: () => void
  onLock?: () => void
  onMinimize?: () => void
  onMaximize?: boolean
  onUnlock?: boolean
  nodeId: string
}

// This is a compatibility component to maintain backward compatibility
// The actual functionality has been moved to NodeBaseContainer
const NodeBaseActions: React.FC<NodeBaseActionsProps> = () => {
  return null // This component no longer renders anything
}

export default NodeBaseActions
